import React from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router";
import { SolutionInListApiResponse } from "../types";
import routes from "../../../routes";
import { style } from "./columns";
import solutionTableColumns from "./columns";
import Material7Autocomplete from "../../../shared/Material7Autocomplete";

// DataGrid renders every row on one page for this sentinel page size.
const ALL_ROWS_PAGE_SIZE = -1;

type Props = {
  solutionList: SolutionInListApiResponse[];
  loading: boolean;
};

const SolutionTable: React.FC<Props> = ({ solutionList, loading }) => {
  const navigate = useNavigate();

  return (
    <Box data-testid="solution-list-table-container" sx={style.listContainer}>
      <DataGrid
        data-testid="solution-list-table"
        sx={style.list}
        rows={solutionList}
        columns={solutionTableColumns}
        disableRowSelectionOnClick
        loading={loading}
        onRowClick={(params) =>
          navigate(routes.solutions.view({ id: params.id.toString() }))
        }
        showToolbar
        slots={{
          baseAutocomplete: Material7Autocomplete,
        }}
        pageSizeOptions={[
          25,
          50,
          100,
          { value: ALL_ROWS_PAGE_SIZE, label: "All" },
        ]}
        initialState={{
          pagination: { paginationModel: { pageSize: ALL_ROWS_PAGE_SIZE } },
        }}
      />
    </Box>
  );
};

export default SolutionTable;
